import axios from "axios";
import normalize from "jsonapi-normalizer";

var parseLinkHeader = require("parse-link-header");

const getOrganizationSessions = (context, payload = { page: 1 }) => {
  axios
    .get(`organizations/${payload.id}/sessions?page=${payload.page}`, {
      data: {},
    })
    .then((response) => {
      context.commit("ORGANIZATION_SESSIONS_VIEW_UPDATED", {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers["per-page"],
        context: "Organization Sessions",
        collectionId: payload.id,
      });
      context.commit("ORGANIZATION_SESSIONS_UPDATED", response.data);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
    });
};

const getOrganizationRevisions = (context, payload = { page: 1 }) => {
  axios
    .get(`organizations/${payload.id}/revisions?page=${payload.page}`, {
      data: {},
    })
    .then((response) => {
      context.commit("ORGANIZATION_REVISIONS_VIEW_UPDATED", {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers["per-page"],
        context: "Organization Create Revisions",
        collectionId: payload.id,
      });
      context.commit("ORGANIZATION_REVISIONS_UPDATED", response.data);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
    });
};

const getOrganizationCreateRevisions = (context, payload = { page: 1 }) => {
  axios
    .get(`organizations/${payload.id}/create_revisions?page=${payload.page}`, {
      data: {},
    })
    .then((response) => {
      context.commit("ORGANIZATION_CREATE_REVISIONS_VIEW_UPDATED", {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers["per-page"],
        context: "Organization Create Revisions",
        collectionId: payload.id,
      });
      context.commit("ORGANIZATION_CREATE_REVISIONS_UPDATED", response.data);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
    });
};

const getOrganizationUpdateRevisions = (context, payload = { page: 1 }) => {
  axios
    .get(`organizations/${payload.id}/update_revisions?page=${payload.page}`, {
      data: {},
    })
    .then((response) => {
      context.commit("ORGANIZATION_UPDATE_REVISIONS_VIEW_UPDATED", {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers["per-page"],
        context: "Organization Create Revisions",
        collectionId: payload.id,
      });
      context.commit("ORGANIZATION_UPDATE_REVISIONS_UPDATED", response.data);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
    });
};

const getOrganizationDestroyRevisions = (context, payload = { page: 1 }) => {
  axios
    .get(`organizations/${payload.id}/destroy_revisions?page=${payload.page}`, {
      data: {},
    })
    .then((response) => {
      context.commit("ORGANIZATION_DESTROY_REVISIONS_VIEW_UPDATED", {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers["per-page"],
        context: "Organization Create Revisions",
        collectionId: payload.id,
      });
      context.commit("ORGANIZATION_DESTROY_REVISIONS_UPDATED", response.data);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
    });
};

const getUserRevisions = (context, payload = { page: 1 }) => {
  axios
    .get(`users/${payload.id}/revisions?page=${payload.page}`, {
      data: {},
    })
    .then((response) => {
      context.commit("USER_REVISIONS_VIEW_UPDATED", {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers["per-page"],
        context: "User Revisions",
        collectionId: payload.id,
      });
      context.commit("USER_REVISIONS_UPDATED", response.data);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      context.commit("USER_REVISIONS_ERROR", error.message);
    });
};

const getUserActions = (context, payload = { page: 1 }) => {
  axios
    .get(`users/${payload.id}/activities?page=${payload.page}`, {
      data: {},
    })
    .then((response) => {
      context.commit("USER_ACTIONS_VIEW_UPDATED", {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers["per-page"],
        context: "User Revisions",
        collectionId: payload.id,
      });
      context.commit("USER_ACTIONS_UPDATED", response.data);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      context.commit("USER_REVISIONS_ERROR", error.message);
    });
};

const clearUserRevisionsError = (context) => {
  context.commit("USER_REVISIONS_ERROR", null);
};

const setChangeAudit = (context, payload) => {
  context.commit("CHANGE_AUDIT_UPDATED", payload);
};

const getUsers = (context, payload) => {
  var request_string = "/users/";
  if (payload.orgId) {
    request_string = `organizations/${payload.orgId}/users`;
  }
  axios
    .get(request_string, {
      params: {
        skip: 0,
        limit: 100,
        sort: payload.sort,
      },
    })
    .then((response) => {
      context.commit("USER_LIST_VIEW_UPDATED", {
        headerLinks: null,
        total: response.data.meta.pagination.count,
        perPage: response.data.meta.pagination.limit,
        context: "User List",
        collectionId: payload.orgId,
        sort: payload.sort,
      });
      context.commit("USER_LIST_UPDATED", response.data);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      context.commit("USER_REVISIONS_ERROR", error.message);
    });
};

const removeUser = (context, payload) => {
  context.commit("USER_LIST_REMOVE_ITEM", payload);
};

const deleteUser = (context, payload) => {
  axios
    .delete(`users/${payload.id}`)
    .then((response) => {
      console.log(response);
      context.commit("USER_LIST_REMOVE_ITEM", payload.id);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      context.commit("USER_REVISIONS_ERROR", error.message);
    });
};

const addUser = (context, payload) => {
  context.commit("USER_LIST_ADD_ITEM", payload);
};

const updateUser = (context, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .patch(`/users/${payload.id}`, {
        data: {
          type: "users",
          attributes: payload.attributes,
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            const { entities } = normalize(response.data);
            // Use commit to global states with root set to true
            context.commit("MODIFY_USER", entities.users[payload.id], {
              root: true,
            }); // Does not update Session User Object
            context.commit(
              "UPDATE_SESSION",
              {
                user: entities.users[payload.id],
              },
              { root: true }
            );
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const getBroadcasts = (context, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`organizations/${payload.organization_id}/broadcasts`, {
        data: {},
      })
      .then(
        (response) => {
          if (response.status === 200) {
            context.commit("SET_BROADCASTS", {
              data: response.data.data,
              meta: {
                total: response.headers.total,
              },
            });
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const addBroadcast = (context, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`organizations/${payload.organization_id}/broadcasts`, {
        data: {
          subject: payload.subject,
          body: payload.body,
          important: payload.important,
          message_type: payload.message_type,
        },
      })
      .then(
        (response) => {
          if (response.status === 201) {
            window.console.log(response.data.data);
            context.commit("ADD_BROADCAST", {
              data: response.data.data,
            });
            window.console.log(response.data);
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const getJoinRequests = (context, payload = { page: 1 }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `organizations/${payload.organization_id}/join_requests?page=${payload.page}`,
        {
          data: {
            organization_id: payload.organization_id,
          },
          params: payload.params,
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            context.commit("ADD_JOIN_REQUESTS", {
              data: response.data.data,
              meta: response.data.meta,
              headerLinks: parseLinkHeader(response.headers.link),
              total: response.headers.total,
              perPage: response.headers["per-page"],
              context: "OrganizationJoinRequests",
              collectionId: payload.organization_id,
            });
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const getSimpleJoinRequests = (context, payload = { page: 1 }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `organizations/${payload.organization_id}/simple_join_requests?page=${payload.page}`,
        {
          data: {
            organization_id: payload.organization_id,
          },
          params: payload.params,
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            context.commit("ADD_SIMPLE_JOIN_REQUESTS", {
              data: response.data.data,
              meta: response.data.meta,
              headerLinks: parseLinkHeader(response.headers.link),
              total: response.headers.total,
              perPage: response.headers["per-page"],
              context: "OrganizationSimpleJoinRequests",
              collectionId: payload.organization_id,
            });
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const getPackets = (context, payload = { page: 1 }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `organizations/${payload.organization_id}/packets?page=${payload.page}`,
        {
          data: {
            organization_id: payload.organization_id,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            context.commit("ADD_PACKETS", {
              data: response.data.data,
              meta: response.data.meta,
              headerLinks: parseLinkHeader(response.headers.link),
              total: response.headers.total,
              perPage: response.headers["per-page"],
              context: "OrganizationPackets",
              collectionId: payload.organization_id,
            });
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const getNetworkStatistics = (context, payload = { page: 1 }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `organizations/${payload.organization_id}/network_statistics?page=${payload.page}`,
        {
          data: {
            organization_id: payload.organization_id,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            context.commit("ADD_NETWORK_STATISTICS", {
              data: response.data.data,
              meta: response.data.meta,
              headerLinks: parseLinkHeader(response.headers.link),
              total: response.headers.total,
              perPage: response.headers["per-page"],
              context: "OrganizationNetworkStatistics",
              collectionId: payload.organization_id,
            });
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const getGatewayStatistics = (context, payload = { page: 1 }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `organizations/${payload.organization_id}/gateway_statistics?page=${payload.page}`,
        {
          data: {
            organization_id: payload.organization_id,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            context.commit("ADD_GATEWAY_STATISTICS", {
              data: response.data.data,
              meta: response.data.meta,
              headerLinks: parseLinkHeader(response.headers.link),
              total: response.headers.total,
              perPage: response.headers["per-page"],
              context: "OrganizationGatewayStatistics",
              collectionId: payload.organization_id,
            });
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const getJoinRequestsQuantities = (context, payload = { page: 1 }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `organizations/${payload.organization_id}/join_requests_quantities?page=${payload.page}`,
        {
          data: {
            organization_id: payload.organization_id,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            context.commit("ADD_JOIN_REQUESTS_QUANTITIES", {
              data: response.data.data,
              meta: response.data.meta,
              headerLinks: parseLinkHeader(response.headers.link),
              total: response.headers.total,
              perPage: response.headers["per-page"],
              context: "OrganizationJoinRequestsQuantities",
              collectionId: payload.organization_id,
            });
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const getPacketsQuantities = (context, payload = { page: 1 }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `organizations/${payload.organization_id}/packets_quantities?page=${payload.page}`,
        {
          data: {
            organization_id: payload.organization_id,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            context.commit("ADD_PACKETS_QUANTITIES", {
              data: response.data.data,
              meta: response.data.meta,
              headerLinks: parseLinkHeader(response.headers.link),
              total: response.headers.total,
              perPage: response.headers["per-page"],
              context: "OrganizationPacketsQuantities",
              collectionId: payload.organization_id,
            });
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const getStats = (context, payload = { page: 1 }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `organizations/${payload.organization_id}/stats?page=${payload.page}`,
        {
          data: {
            organization_id: payload.organization_id,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            context.commit("ADD_STATS", {
              data: response.data.data,
              meta: response.data.meta,
              headerLinks: parseLinkHeader(response.headers.link),
              total: response.headers.total,
              perPage: response.headers["per-page"],
              context: "OrganizationStats",
              collectionId: payload.organization_id,
            });
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const getCrcErrors = (context, payload = { page: 1 }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `organizations/${payload.organization_id}/crc_errors?page=${payload.page}`,
        {
          data: {
            organization_id: payload.organization_id,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            context.commit("ADD_CRC_ERRORS", {
              data: response.data.data,
              meta: response.data.meta,
              headerLinks: parseLinkHeader(response.headers.link),
              total: response.headers.total,
              perPage: response.headers["per-page"],
              context: "OrganizationCrcErrors",
              collectionId: payload.organization_id,
            });
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const getMissedPackets = (context, payload = { page: 1 }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `organizations/${payload.organization_id}/missed_packets?page=${payload.page}`,
        {
          data: {
            organization_id: payload.organization_id,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            context.commit("ADD_MISSED_PACKETS", {
              data: response.data.data,
              meta: response.data.meta,
              headerLinks: parseLinkHeader(response.headers.link),
              total: response.headers.total,
              perPage: response.headers["per-page"],
              context: "OrganizationMissedPackets",
              collectionId: payload.organization_id,
            });
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const getSearchResults = (context, payload) => {
  return new Promise((resolve, reject) => {
    context.commit("ADD_SEARCH_RESULTS", { data: null });
    axios.get(`/search?q=${payload}`).then(
      (response) => {
        if (response.status === 200) {
          context.commit("ADD_SEARCH_RESULTS", {
            data: response.data,
          });
        }
        resolve(response);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

const getSystemSummary = (context, payload) => {
  return new Promise((resolve, reject) => {
    context.commit("ADD_SYSTEM_SUMMARY", { meta: null });
    axios
      .get(`organizations/${payload.organization_id}/system_summary`, {
        data: {
          organization_id: payload.organization_id,
        },
      })
      .then(
        (response) => {
          console.log("getSystemSummary...do it");
          if (response.status === 200) {
            console.log("no, really...getSystemSummary...do it");
            context.commit("ADD_SYSTEM_SUMMARY", {
              meta: response.data.meta,
              context: "System Summary",
            });
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const getLicenses = (context, payload = { page: 1 }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`tokens?page=${payload.page}`, {
        data: {
          organization_ids: payload.organization_ids,
        },
        params: payload.params,
      })
      .then(
        (response) => {
          if (response.status === 200) {
            context.commit("SET_LICENSES", {
              data: response.data.data,
              meta: response.data.meta,
              headerLinks: parseLinkHeader(response.headers.link),
              total: response.headers.total,
              perPage: response.headers["per-page"],
              context: "VaultTokenTrans",
              collectionId: 1,
            });
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const updateLicense = (context, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .patch(`/tokens/${payload.id}`, {
        data: {
          ...payload.params,
        },
      })
      .then(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const getOrganizationScheduleProvisioning = (context, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`organizations/${payload.organization_id}/schedule_provisioning`)
      .then(
        (response) => {
          if (response.status === 200) {
            let res_arr = [];
            let res_data = response.data.data;
            let res_included = response.data.included;

            for (let i in res_data) {
              let res_schedule_provisioning_application_networks_join =
                res_data[i].relationships
                  .schedule_provisioning_application_networks.data;
              let application_networks = [];
              for (let j in res_schedule_provisioning_application_networks_join) {
                let span_id =
                  res_schedule_provisioning_application_networks_join[j].id;
                const schedule_provisioning_application_network_obj =
                  res_included.find((span) => span.id == span_id);
                application_networks.push(
                  schedule_provisioning_application_network_obj.relationships
                    .application_network.data.id
                );
              }

              let res_item = {
                id: res_data[i].id,
                deviceType: res_data[i].attributes.device_type,
                devicesProvisionedOnLastRun: res_data[i].attributes
                  .devices_provisioned_on_last_run
                  ? res_data[i].attributes.devices_provisioned_on_last_run
                  : 0,
                sku: res_data[i].attributes.sku,
                applicationNetworks: application_networks,
                lastRunOn: new Date(
                  res_data[i].attributes.updated_at
                ).toUTCString(),
              };
              res_arr.push(res_item);
            }
            context.commit("SET_ORGANIZATION_SCHEDULE_PROVISIONING", res_arr);
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const addOrganizationScheduleProvisioning = (context, payload) => {
  const req = {
    data: {
      type: "schedule_provisionings",
      attributes: {
        organization_id: payload.organization_id,
        sku: payload.sku,
        device_type: payload.device_type,
        application_networks: payload.application_networks,
      },
    },
  };
  return new Promise((resolve, reject) => {
    axios
      .post(
        `organizations/${payload.organization_id}/schedule_provisioning`,
        req
      )
      .then(
        (response) => {
          if (response.status === 201) {
            let res_data = response.data.data;
            let res_included = response.data.included;

            let res_schedule_provisioning_application_networks_join =
              res_data.relationships.schedule_provisioning_application_networks
                .data;
            let application_networks = [];
            for (let j in res_schedule_provisioning_application_networks_join) {
              let span_id =
                res_schedule_provisioning_application_networks_join[j].id;
              const schedule_provisioning_application_network_obj =
                res_included.find((span) => span.id == span_id);
              application_networks.push(
                schedule_provisioning_application_network_obj.relationships
                  .application_network.data.id
              );
            }
            let res_item = {
              id: res_data.id,
              deviceType: res_data.attributes.device_type,
              devicesProvisionedOnLastRun: res_data.attributes
                .devices_provisioned_on_last_run
                ? res_data.attributes.devices_provisioned_on_last_run
                : 0,
              sku: res_data.attributes.sku,
              applicationNetworks: application_networks,
              lastRunOn: new Date(res_data.attributes.updated_at).toUTCString(),
            };
            context.commit("ADD_ORGANIZATION_SCHEDULE_PROVISIONING", res_item);
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const deleteOrganizationScheduleProvisioning = (context, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(
        `organizations/${payload.organization_id}/schedule_provisioning/${payload.id}`
      )
      .then(
        (response) => {
          console.log("deleting schedule provisioning...do it");
          if (response.status === 204) {
            context.commit(
              "REMOVE_ORGANIZATION_SCHEDULE_PROVISIONING",
              `${payload.id}`
            );
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

export default {
  getBroadcasts,
  addBroadcast,
  getOrganizationSessions,
  getOrganizationRevisions,
  getOrganizationCreateRevisions,
  getOrganizationUpdateRevisions,
  getOrganizationDestroyRevisions,
  getUserRevisions,
  getUserActions,
  clearUserRevisionsError,
  setChangeAudit,
  getUsers,
  removeUser,
  deleteUser,
  addUser,
  updateUser,
  getJoinRequests,
  getSimpleJoinRequests,
  getPackets,
  getNetworkStatistics,
  getGatewayStatistics,
  getJoinRequestsQuantities,
  getPacketsQuantities,
  getStats,
  getCrcErrors,
  getMissedPackets,
  getSearchResults,
  getSystemSummary,
  getLicenses,
  updateLicense,
  getOrganizationScheduleProvisioning,
  deleteOrganizationScheduleProvisioning,
  addOrganizationScheduleProvisioning,
};



// WEBPACK FOOTER //
// ./src/modules/organizationStates/store/actions.js